import {listGender} from "data/list";
import moment from "moment";
import DilateStatusCard from "components/common/DilateStatusCard/DilateStatusCard";
import React from "react";
import {FIELD_TYPE, FORMAT_TIME} from "types/enums";
import {ColumnProps} from "types/models";
import {DataFormField} from "types/models/input-field-type";
import {ColumnsEdit} from "types/models/column-table-edit";
import {
  birthday2Age,
  convertDateStringToDateTimezone_7,
  convertDateStringToDateTimezone_7Dayjs,
} from "helper/common";
import PatientTypeColumn from "components/common/ColumnColors/KCBTypeColumn/PatientTypeColumn";
import {loaiBNOptions} from "assets/constants/kbnt-category";
import KCBTypeColumn from "components/common/ColumnColors/KCBTypeColumn/KCBTypeColumn";
import KCBStatusColumn from "components/common/ColumnColors/KCBTypeColumn/KCBStatusColumn";
const {INPUT, DATE, COMBO_BOX, NUMBER} = FIELD_TYPE;

const listPatient = () => {
  const listPatient: DataFormField[] = [
    {
      type: INPUT,
      label: "Mã phiếu khám",
      name: "idPhieuKham",
      expand: false,
    },
    {
      type: INPUT,
      label: "Mã bệnh nhân",
      name: "maBenhNhan",
      expand: false,
    },
    {
      type: INPUT,
      label: "Tên bệnh nhân",
      name: "hoTen",
      expand: false,
    },
    {
      type: DATE,
      label: "Ngày sinh",
      name: "ngaySinh",
      expand: false,
    },
    {
      type: COMBO_BOX,
      label: "Phòng",
      name: "idPhong",
      expand: false,
      options: JSON.parse(localStorage.getItem("phongKhamNoPeople")),
    },

    {
      type: COMBO_BOX,
      label: "Giới tính",
      name: "gioiTinh",
      expand: true,
      options: listGender,
    },
    {
      type: INPUT,
      label: "Số thẻ BHYT",
      name: "soTheBHYT",
      expand: true,
    },
    {
      type: INPUT,
      label: "Số điện thoại",
      name: "dienThoai",
      expand: true,
    },
    {
      type: INPUT,
      label: "Bác sĩ chỉ định",
      name: "bsChiDinh",
      expand: true,
    },
    {
      type: COMBO_BOX,
      label: "Trạng thái BH",
      placeholder: "Chọn",
      name: "trangThaiBH",
      options: JSON.parse(localStorage.getItem("TTBH")),
      expand: true,
    },
    {
      type: COMBO_BOX,
      label: "Loại KCB",
      placeholder: "Chọn",
      name: "loaiKCB",
      options: JSON.parse(localStorage.getItem("loaiKCB")),
      expand: true,
    },
    {
      type: DATE,
      label: "Ngày tạo từ",
      name: "ngayTaoTu",
      optionsTime: {showTime: false, format: FORMAT_TIME.dayFull},
      expand: true,
      disableDate: false,
    },
    {
      type: DATE,
      label: "Ngày tạo đến",
      name: "ngayTaoDen",
      optionsTime: {showTime: false, format: FORMAT_TIME.dayFull},
      expand: true,
      disableDate: false,
    },
    {
      type: COMBO_BOX,
      label: "Trạng thái TV",
      name: "trangThai",
      options: JSON.parse(localStorage.getItem("TTPhieu")),
      expand: true,
    },

    {
      type: COMBO_BOX,
      label: "Khu KCB",
      placeholder: "Chọn",
      name: "khuKCB",
      expand: true,
      options: JSON.parse(localStorage.getItem("khuKham")),
    },
  ];
  return listPatient;
};

const listPatientColumns: ColumnsEdit = [
  {
    title: "STT",
    dataIndex: "stt",
    key: "stt",
    show: true,
    isResizable: true,
    fixed: "left",
    width: 70,
    align: "center",
  },
  {
    title: "Mã BN",
    dataIndex: "maBenhNhan",
    key: "maBenhNhan",
    show: true,
    isResizable: true,
    align: "center",
    width: 80,
  },
  {
    title: "Mã PK",
    dataIndex: "idPhieuKham",
    key: "idPhieuKham",
    show: true,
    isResizable: true,
    align: "center",
    width: 80,
  },
  {
    title: "Số thẻ BHYT",
    dataIndex: "maTheBhyt",
    key: "maTheBhyt",
    show: true,
    isResizable: true,
    align: "left",
    width: 150,
  },
  {
    title: "Tên BN",
    dataIndex: "hoTen",
    key: "hoTen",
    show: true,
    isResizable: true,
    align: "left",
    width: 150,
  },
  {
    title: "Giới tính",
    dataIndex: "gioiTinh",
    key: "gioiTinh",
    show: true,
    isResizable: true,
    align: "left",
    render: text => {
      if (text == "0") {
        return "Nam";
      } else if (text == "1") {
        return "Nữ";
      } else return "";
    },
    width: 80,
  },
  {
    title: "Ngày sinh",
    dataIndex: "ngaySinh",
    key: "ngaySinh",
    show: true,
    isResizable: true,
    align: "center",
    render: (text, record) =>
      text
        ? convertDateStringToDateTimezone_7(text).format(FORMAT_TIME.dayFull)
        : "",
    width: 150,
  },
  {
    title: "Tuổi",
    key: "tuoi",
    dataIndex: "tuoi",
    render: (text, record: {ngaySinh: Date}) => {
      return record.ngaySinh ? birthday2Age(record.ngaySinh) : "";
    },
    show: true,
    isResizable: true,
    width: 70,
    align: "center",
  },
  {
    title: "Ngày tạo",
    key: "ngayTao",
    dataIndex: "ngayTao",
    render: (text, record) => convertDateStringToDateTimezone_7Dayjs(text),
    show: true,
    isResizable: true,
    width: 150,
    align: "center",
  },
  {
    title: "Địa chỉ",
    dataIndex: "diaChiTongHop",
    key: "diaChiTongHop",
    show: false,
    isResizable: true,
    align: "left",
    width: 200,
  },
  {
    title: "Số điện thoại",
    dataIndex: "dienThoai",
    key: "dienThoai",
    show: false,
    isResizable: true,
    align: "right",
    width: 150,
  },
  {
    title: "Tình trạng PT",
    dataIndex: "tinhTrangPhauThuat",
    key: "tinhTrangPhauThuat",
    show: true,
    isResizable: true,
    align: "right",
    width: 150,
  },
  {
    title: "Lý do",
    dataIndex: "lyDoTuChoiPT",
    key: "lyDoTuChoiPT",
    show: true,
    isResizable: true,
    align: "left",
    width: 150,
  },
  {
    title: "Loại KCB",
    key: "loaiKCB",
    dataIndex: "loaiKCB",
    show: true,
    isResizable: true,
    width: 150,
    render: text => {
      const ten =
        JSON.parse(localStorage.getItem("loaiKCB")).find(
          option => option.value === text
        )?.label || "";
      return <KCBTypeColumn label={ten} />;
    },
  },
  {
    title: "Loại bệnh nhân",
    dataIndex: "loaiBenhNhans",
    key: "loaiBenhNhans",
    show: true,
    isResizable: true,
    // disabledCheck: true,
    width: 130,
    align: "center",
    render: text => {
      const loaiBN =
        loaiBNOptions.find(option => option.value === text?.[0])?.label || "";
      return <PatientTypeColumn label={loaiBN} />;
    },
  },
  {
    title: "BS chỉ định",
    key: "bacSyChiDinh",
    dataIndex: "bacSyChiDinh",
    show: true,
    isResizable: true,
    width: 150,
  },
  {
    title: "Trạng thái TV",
    key: "trangThai",
    dataIndex: "trangThai",
    show: true,
    isResizable: true,
    width: 150,
    render: text => {
      const ten =
        JSON.parse(localStorage.getItem("TTPhieu")).find(
          option => option.value === text
        )?.label || "";
      return <KCBStatusColumn label={ten} />;
    },
  },
  {
    title: "Trạng thái BH",
    key: "trangThaiBH",
    dataIndex: "trangThaiBH",
    show: true,
    isResizable: true,
    width: 150,
    render: text => {
      return (
        JSON.parse(localStorage.getItem("TTBH")).find(
          option => option.value === text
        )?.label || ""
      );
    },
  },
  {
    title: "Thao tác",
    dataIndex: "action",
    show: true,
    isResizable: true,
    align: "center",
    fixed: "right",
    width: 150,
  },
];

export {listPatient, listPatientColumns};
